// 判断是小程序环境
const getMP = (userAgent = navigator.userAgent) => {
  if (userAgent.indexOf('AlipayClient') > -1) {
    return true
    // 支付宝小程序
  } else if (/QQ/i.test(userAgent) && /miniProgram/i.test(userAgent)) {
    // QQ 小程序
    return true
  } else if (/miniProgram/i.test(userAgent)) {
    // 微信小程序
    return true
  } else if (/toutiaomicroapp/i.test(userAgent)) {
    // 头条小程序
    return true
  } else if (/swan/i.test(userAgent)) {
    // 百度小程序
    return true
  } else {
    return false
  }
}

export default getMP
